// extracted by mini-css-extract-plugin
export default {"incentivised":"qUTov"};